import React, {useEffect, useState} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux'
import {
    Head,
    Tree,
} from "../../components";
import {Paper} from "@mui/material";
import {Tooltip} from "@mui/material";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import {Link} from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import {Box} from "@mui/material";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {FETCH_NODES, TOGGLE_CHECKED, TOGGLE_EXPANDED} from "../../types";
import Api from "../../utils/api";
import {treeAction} from "../../actions";
import RegionEdit from "../../components/Region/edit";
import RegionCreat from "../../components/Region/create";

const Region = () => {

    const dispatch = useDispatch();

    const AppState = useSelector(state => state);

    useEffect(() => {
        dispatch({type: TOGGLE_CHECKED, payload: []});
        dispatch({type: TOGGLE_EXPANDED, payload: []});
        dispatch({type: FETCH_NODES, payload: []});
        handleRequest();
    }, []);

    const handleRequest = () => {
        dispatch(treeAction.region());
    }

    const expandScrolling = (expanded, nodes) => {

        nodes.map((node) => {
            expanded.push(node.id);
            expandScrolling(expanded,node.children);
        });

        return expanded;
    }

    const handleToggleExpand = () => {

        if (AppState.treeReducer.expanded.length === 0) {
            dispatch({type: TOGGLE_EXPANDED, payload: expandScrolling(AppState.treeReducer.expanded, AppState.treeReducer.nodes) });
        } else {
            dispatch({type: TOGGLE_EXPANDED, payload: []});
        }

    }


    const handleChangeSort = (type) => {
            new Api().put('/region/' + AppState.treeReducer.checked.join(',') + '/movement', {type: type}).then((response) => {
                if (typeof response !== "undefined") {
                    handleRequest();
                }
            })
    }



    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'مدیریت مناطق', 'description': 'مناطق  را مدیریت نمایید.' }} />
            <Box className='display-flex display-flex-justify-content-space-between'>
                <div></div>
                <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                    <RegionCreat checked={AppState.treeReducer.checked} reload={() => handleRequest()} />
                    {AppState.treeReducer.checked.length > 0 && <Tooltip title="تغییر اولویت">
                        <IconButton onClick={() => handleChangeSort('up')}>
                            <ArrowUpwardIcon />
                        </IconButton>
                    </Tooltip>}
                    {AppState.treeReducer.checked.length > 0 && <Tooltip title="تغییر اولویت">
                        <IconButton onClick={() => handleChangeSort('down')}>
                            <ArrowDownwardIcon />
                        </IconButton>
                    </Tooltip>}
                    {AppState.treeReducer.checked.length === 1 && <RegionEdit checked={AppState.treeReducer.checked} reload={() => handleRequest()}/>}
                    <Tooltip title="باز و بسته کردن">
                        <IconButton onClick={() => handleToggleExpand()}>
                            <AspectRatioIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="سینک">
                        <IconButton onClick={() => handleRequest()} >
                            <SyncIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            </Box>
            <Paper elevation={1}>
                <Tree nodes={AppState.treeReducer.nodes} />
            </Paper>
        </Container>

    );
}


export default Region
